import React from "react";
import EN from "../../locales/en";
import SelectField from "./partials/SelectField";
import TextField from "./partials/TextField";

const YourPersonalDetails = ({ switchValidationSchema }) => {
  return (
    <div className="mt-8 border-t border-[#afb6b9]">
      <h2 className="text-[30px] font-bold text-primary mt-6">
        {EN.switch.your_personal_details.title}
      </h2>
      <h3 className="text-[22px] font-bold mt-4">
        {EN.switch.your_personal_details.name_section_title}
      </h3>
      <div className="space-y-4">
        <SelectField
          key="customerInfo.custTitle"
          name="customerInfo.custTitle"
          label={EN.switch.your_personal_details.title_label}
          options={
            switchValidationSchema?.customerInfo?.properties?.custTitle
              ?.valid ?? []
          }
          defaultText={EN.switch.your_personal_details.title_default_text}
        />

        <TextField
          key="customerInfo.custForename"
          name="customerInfo.custForename"
          label={EN.switch.your_personal_details.first_name_label}
          placeholder={EN.switch.your_personal_details.first_name_placeholder}
        />

        <TextField
          key="customerInfo.custLastName"
          name="customerInfo.custLastName"
          label={EN.switch.your_personal_details.last_name_label}
          placeholder={EN.switch.your_personal_details.last_name_placeholder}
        />
      </div>

      <h3 className="text-[22px] font-bold mt-6">
        {EN.switch.your_personal_details.dob_section_title}
      </h3>
      <TextField
        key="customerInfo.custDateofBirth"
        name="customerInfo.custDateofBirth"
        type="date"
      />
    </div>
  );
};

export default YourPersonalDetails;
